<template>
  <base-modal
    hide-footer
    :size="'lg'"
    :modal-id="'mapping-category'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
  >
    <template #modal-header>
      <div class="head-label">
        <span>Mapping Category</span> : {{ privilegeObj.name_en }}
      </div>
    </template>
    <b-row>
      <b-col
        cols="12"
        class="px-2"
      >
        <search :on-search-input="onSetValueSearch" />
      </b-col>
      <b-col
        cols="12"
        class="px-2 mt-2"
      >
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields"
              :items="categoryList.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              class="mapping-category-table"
            >
              <template #cell(category_image_url)="data">
                <div class="mapping-cate-icon">
                  <img
                    class="w-100"
                    :src="data.value || DefaultImg"
                    alt=""
                    draggable="false"
                  >
                </div>
              </template>
              <template #cell(category_sub_image_url)="data">
                <div class="mapping-cate-icon">
                  <img
                    class="w-100"
                    :src="data.value || DefaultImg"
                    alt=""
                    draggable="false"
                  >
                </div>
              </template>
              <template #cell(category_name)="data">
                <div>
                  {{ data.item.name_en }}
                </div>
                <div>
                  {{ data.item.name_th }}
                </div>
              </template>
              <template #cell(actions)="row">
                <div class="d-flex align-item-center">
                  <div
                    class="mapping-primary-btn mr-4"
                    :class="
                      resolvePrimaryMapping(row.item.category_id)
                        ? 'primary'
                        : ''
                    "
                    @click="onAssignCategory(row.item.category_id)"
                  >
                    {{ 'Primary' }}
                  </div>
                  <div
                    class="mapping-cate-btn mr-4"
                    :class="
                      resolveCategoryMapping(row.item.category_id)
                        ? 'mapping'
                        : ''
                    "
                    @click="onMappingCategory(row.item.category_id)"
                  >
                    {{
                      resolveCategoryMapping(row.item.category_id)
                        ? 'Un-Mapping'
                        : 'Mapping'
                    }}
                  </div>
                  <b-button
                    v-if="!row.item.sub_category.length == 0"
                    v-b-tooltip.hover
                    variant="secondary"
                    class="btn-expand-cate banner-action mr-2 iconSvg-btn"
                    title="Show more"
                    @click="onExpandTable(row)"
                  >
                    <icon-expand-table
                      class="banner-group-action-svg"
                      :class="row.detailsShowing ? 'active' : ''"
                    />
                  </b-button>
                </div>
              </template>
              <template #row-details="row">
                <div>
                  <b-table
                    :fields="fields"
                    :items="row.item.sub_category"
                    responsive
                    bordered
                    borderless
                    sticky-header
                    class="mapping-category-table-inside"
                  >
                    <template #cell(category_image_url)="data">
                      <div class="mapping-cate-icon">
                        <img
                          class="w-100"
                          :src="data.value || DefaultImg"
                          alt=""
                          draggable="false"
                        >
                      </div>
                    </template>
                    <template #cell(category_sub_image_url)="data">
                      <div class="mapping-cate-icon">
                        <img
                          class="w-100"
                          :src="data.value || DefaultImg"
                          alt=""
                          draggable="false"
                        >
                      </div>
                    </template>
                    <template #cell(category_name)="data">
                      <div>
                        {{ data.item.name_en }}
                      </div>
                      <div>
                        {{ data.item.name_th }}
                      </div>
                    </template>
                    <template #cell(actions)="row">
                      <div class="d-flex">
                        <div
                          class="mapping-primary-btn mr-4"
                          :class="
                            resolvePrimaryMapping(row.item.category_id)
                              ? 'primary'
                              : ''
                          "
                          @click="onAssignCategory(row.item.category_id)"
                        >
                          {{ 'Primary' }}
                        </div>
                        <div
                          class="mapping-cate-btn"
                          :class="
                            resolveCategoryMapping(row.item.category_id)
                              ? 'mapping'
                              : ''
                          "
                          @click="onMappingCategory(row.item.category_id)"
                        >
                          {{
                            resolveCategoryMapping(row.item.category_id)
                              ? 'Un-Mapping'
                              : 'Mapping'
                          }}
                        </div>
                      </div>
                    </template>
                  </b-table>
                </div>
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          :pagination="pagination"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
    <b-row class="modal-body-container mb-1" />
  </base-modal>
</template>

<script>
import BaseModal from '@/@core/components/base-modal/BaseModal.vue'
import Search from '@/views/components/search/Search.vue'
import AddButton from '@/views/components/button/AddButton.vue'
import IconExpandTable from '@/@core/components/svg/common/IconExpandTable.vue'
import DefaultImg from '@/assets/images/icons/no-img-square.jpg'
import PaginationWithReorder from '@/views/components/pagination/PaginationWithReorder.vue'
import useMappingCategoryModal from '../hooks/useMappingCategoryModal'

export default {
  components: {
    BaseModal,
    Search,
    AddButton,
    IconExpandTable,
    PaginationWithReorder,
  },
  props: {
    privilegeObj: { type: Object, default: {} },
  },
  setup(props) {
    const {
      pagination,
      categoryList,
      fields,
      loading,
      onPageChange,
      onModalOpen,
      onExpandTable,
      onSetValueSearch,
      resolvePrimaryMapping,
      resolveCategoryMapping,
      onAssignCategory,
      onMappingCategory,
    } = useMappingCategoryModal(props)
    return {
      DefaultImg,
      categoryList,
      fields,
      loading,
      pagination,
      onPageChange,
      onModalOpen,
      onExpandTable,
      onSetValueSearch,
      resolvePrimaryMapping,
      resolveCategoryMapping,
      onAssignCategory,
      onMappingCategory,
    }
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/privilege/mapping-category.css';
@import '~@/assets/css/pages/banner/banner-table.css';
</style>
